module.exports = __webpack_public_path__ + "media/components/resources/svgs/ic_bronze_check-137db8d1d98a166ddfcc5002c02f10f5.svg";